import { alpha } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useEntitiesDrawerStyles = makeStyles(({ spacing, palette, shadows }) =>
  createStyles({
    wrapper: {
      padding: `${spacing(2)} ${spacing(0.5)} ${spacing(2)} ${spacing(2)}`,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    allWrapper: {
      overflow: 'auto',
      paddingBottom: spacing(12),
    },
    listWrapper: {},
    itemWrapper: {
      overscrollBehavior: 'auto',
    },
    item: {
      // 200 - marginRight
      width: `calc(200px - ${spacing(3)})`,
      height: 180,
      display: 'flex',
      flexDirection: 'column',
      boxShadow: shadows[2],
      border: `1px solid ${palette.mode === 'dark' ? '#ffffff' : palette.grey[300]}`,
    },
    listTitle: {
      margin: spacing(),
      display: 'flex',
      alignItems: 'center',
    },
    scrollButton: {
      border: `1px solid ${alpha(palette.primary.main, 0.5)}`,
      boxShadow: shadows[5],
      position: 'absolute',
      backgroundColor: palette.background.paper,
      top: `calc(100px - 25px)`,
      zIndex: 1,
      '&:hover': {
        backgroundColor: palette.primary.light,
      },
    },
    scrollButtonWrapper: {
      width: '100%',
      height: 0,
      position: 'relative',
      overflow: 'visible',
    },
    viewAll: {
      // need important to override leaflet styles
      marginLeft: 'auto',
      width: 'auto !important',
      height: 'auto !important',
      display: 'flex !important',
      border: 'none !important',
      alignItems: 'center',
      background: 'none !important',
      textDecoration: 'underline !important',
      fontSize: 12,
      lineHeight: '1.5 !important',
      fontWeight: '600',

      color: `${palette.primary.main} !important`,
      textDecorationColor: `${alpha(palette.primary.main, 0.4)} !important`,
    },
    gridParent: {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 0 auto',
      overflow: 'auto',
    },
    gridWrapper: {
      height: '100%',
      width: '100%',
    },
    divider: {
      marginBottom: spacing(4),
    },
    content: {
      padding: spacing(),
      display: 'flex',
      flexDirection: 'column',
      flex: '1 0 auto',
    },
    hide: {
      visibility: 'hidden',
      heigth: 0,
    },
    filterMenu: {
      paddingBottom: spacing(4),
    },
    drawerPullerContainer: {
      position: 'absolute',
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
      visibility: 'visible',
      top: 0,
      bottom: 0,
      width: 28,
    },
    drawerPuller: {
      display: 'flex',
      width: 28,
      height: 50,
      backgroundColor: palette.background.paper,
      borderRadius: `3px  0 0 3px`,
      position: 'absolute',
      top: 'calc(50% - 60px)',
      alignItems: 'center',
      borderTop: `1px solid ${palette.grey[600]}`,
      borderBottom: `1px solid ${palette.grey[600]}`,
      borderLeft: `1px solid ${palette.grey[600]}`,
      cursor: 'pointer',
      boxShadow: '-3px 1px 4px -1px rgb(0 0 0 / 36%)',
    },
    drawerContent: {
      height: '100%',
    },
    defaultTranslateX: {
      transform: 'translateX(730px) !important',
    },
  })
);

export default useEntitiesDrawerStyles;
